import React, { useEffect, useState } from 'react';
import './YapayZekaAsistani.css';

// Yapay Zeka Asistanı — menüde yetki gerektirmez, giriş yapan herkese açıktır
// (kullanıcı talebi: 2026-08-20).
//
// Kaynak: C:\inetpub\wwwroot\online\destek.html — bağımsız bir ASP sayfasıydı, buraya taşındı.
// Sohbetin kendisi n8n'de çalışıyor ve iframe ile gömülüyor; bu ekran yalnızca çerçeve,
// başlık ve kullanım kılavuzudur. Adres .env / .env.production içindeki REACT_APP_ASISTAN_URL.
//
// Eski sayfadaki ASP oturum kontrolü (session("whois")) taşınmadı: bu rota zaten
// uygulamanın KorunanRoute'u arkasında, giriş yapmayan buraya ulaşamaz.

const ASISTAN_URL =
  process.env.REACT_APP_ASISTAN_URL ||
  '/webhook/d7b1cffd-b072-4c8f-8422-891530d59a4b/chat';

const KILAVUZ = [
  {
    baslik: 'Fizyoterapist uygun saatleri',
    aciklama: 'Bir fizyoterapistin ilk uygun saatini veya tüm boş saatlerini sorabilirsiniz.',
    ornekler: [
      'Şükrü yarın ilk uygun saati göster',
      'Melek bugün en erken ne zaman müsait?',
      'Şükrü yarın tüm uygun saatleri göster',
      'Mustafa cuma günü hangi saatlerde müsait?',
    ],
  },
  {
    baslik: 'Fizyoterapist dolu randevuları',
    aciklama: 'Bir fizyoterapistin belirli gündeki randevularını hasta isimleriyle görebilirsiniz.',
    ornekler: [
      'Şükrünün yarınki randevularını göster',
      'Melek bugün kimlerle dolu?',
      'Mustafa’nın cuma günü randevuları neler?',
      'Şükrünün yarın saat 14:00 randevusu kim?',
    ],
  },
  {
    baslik: 'Belirli saatte müsait hocalar',
    aciklama: 'Bir gün ve saat vererek o saatte uygun olan fizyoterapistleri listeleyebilirsiniz.',
    ornekler: [
      'Önümüzdeki salı saat 19:00 boş olan hocalar kimler?',
      'Bugün saat 15:00 müsait fizyoterapistler kimler?',
      'Yarın saat 12:30 uygun olan hocaları göster',
    ],
  },
  {
    baslik: 'Hasta randevuları',
    aciklama: 'Bir hastanın kayıtlı randevularını listeleyebilirsiniz.',
    ornekler: [
      'Soner Arslanoğlu isimli hastanın randevuları',
      'Soner Arslanoğlu isimli hasta',
      'Damla Köroğlu randevularını göster',
    ],
  },
  {
    baslik: 'Hasta borç / alacak durumu',
    aciklama: 'Hastanın güncel borç, alacak veya bakiye bilgisini sorabilirsiniz.',
    ornekler: [
      'Soner Arslanoğlu isimli hastanın borcu var mı?',
      'Damla Köroğlu bakiye durumu nedir?',
      'Soner Arslanoğlu’nun alacağı var mı?',
    ],
  },
  {
    baslik: 'Hasta kalan hakları',
    aciklama: 'Hastanın güncel hak grubuna göre kullanılabilir kalan haklarını görebilirsiniz.',
    ornekler: [
      'Soner Arslanoğlu isimli hastanın kaç hakkı var?',
      'Damla Köroğlu’nun kalan hakları neler?',
      'Soner Arslanoğlu’nun seans hakkı kaldı mı?',
    ],
  },
  {
    baslik: 'Hasta son gelişi / son işlemi',
    aciklama: 'Randevu planlamadır; geliş veya işlem ise gerçekleşmiş kayıttır. Son geliş bilgisinde tarih, hizmet ve genel toplam gösterilir.',
    ornekler: [
      'Soner Arslanoğlu isimli hasta en son ne zaman geldi?',
      'Soner Arslanoğlu’nun son gelişi',
      'Damla Köroğlu’nun son faturası',
      'Soner Arslanoğlu’nun son aldığı hizmet nedir?',
    ],
  },
  {
    baslik: 'Şube belirterek sorgu',
    aciklama: 'Sancaktepe, Ataşehir, Mecidiyeköy veya Caddebostan şubesini soru içinde belirtebilirsiniz.',
    ornekler: [
      'Ataşehir şubesinde Melek yarın müsait mi?',
      'Mecidiyeköy Şükrü cuma uygun saatleri göster',
      'Caddebostan Soner Arslanoğlu isimli hastanın borcu var mı?',
    ],
  },
];

export default function YapayZekaAsistani() {
  const [kilavuzAcik, setKilavuzAcik] = useState(false);

  // Orijinal sayfadaki Esc davranışı korundu.
  useEffect(() => {
    if (!kilavuzAcik) return undefined;
    const esc = (e) => { if (e.key === 'Escape') setKilavuzAcik(false); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [kilavuzAcik]);

  return (
    <div className="yza">
      {/* Sayfa başlığı diğer ekranlarla aynı düzende: solda başlık + açıklama, sağda eylem. */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 16, flex: '0 0 auto' }}>
        <div>
          <h2 style={{ marginBottom: 4, color: 'var(--med-dark)' }}>🤖 Dr.Plazma Yapay Zeka Asistanı</h2>
          <p style={{ color: 'var(--text-muted)', margin: 0 }}>
            Merhaba, ben Dr.Plazma yapay zeka asistanıyım benden ne öğrenmek istersin?
          </p>
        </div>
        <button
          className={kilavuzAcik ? 'btn btn-primary' : 'btn btn-secondary'}
          onClick={() => setKilavuzAcik(a => !a)}
          aria-expanded={kilavuzAcik}
          aria-controls="kilavuzPanel"
        >
          {kilavuzAcik ? '💬 Sohbete Dön' : '❔ Nasıl kullanılır?'}
        </button>
      </div>

      {/* Kartın içinde ayrı bir başlık şeridi YOK (kullanıcı talebi: 2026-08-20). Orijinal
          destek.html'deki logo + selamlama + "Aktif" rozeti kaldırıldı: sayfanın kendi başlığı
          zaten aynı bilgiyi veriyordu, "Aktif" ise sabit bir metindi — n8n'e ulaşılıp
          ulaşılmadığını ölçmüyor, servis çökse bile "Aktif" yazardı. */}
      <div className="asistan-kart">
        {kilavuzAcik ? (
          <div className="kilavuz" id="kilavuzPanel">
            <div className="kilavuz-ic">
              <h3>Asistan ile neler yapabilirsiniz?</h3>
              <p className="kilavuz-giris">
                Aşağıdaki örneklerdeki gibi doğal cümlelerle soru sorabilirsiniz.
                Şube belirtmezseniz sorgular Sancaktepe şubesi üzerinden yapılır.
              </p>

              <div className="kilavuz-izgara">
                {KILAVUZ.map(k => (
                  <div className="kilavuz-kutu" key={k.baslik}>
                    <h4>{k.baslik}</h4>
                    <p>{k.aciklama}</p>
                    <ul>
                      {k.ornekler.map(o => <li key={o}>{o}</li>)}
                    </ul>
                  </div>
                ))}
              </div>

              <div className="kilavuz-not">
                Daha iyi sonuç için hasta sorgularında ad-soyad birlikte yazın. Saat bazlı
                sorgularda saati açık belirtin. Uzun geçmiş listeleri yerine “son geliş”,
                “son fatura” veya “son aldığı hizmet” gibi net sorular sorun.
              </div>
            </div>
          </div>
        ) : (
          <div className="sohbet-alan">
            <iframe
              className="sohbet-cerceve"
              src={ASISTAN_URL}
              title="FizyofiPlus Yapay Zeka Asistanı"
              loading="eager"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </div>
    </div>
  );
}
